  document.addEventListener('DOMContentLoaded', function() {
    // Solo inicializar el carrusel en dispositivos móviles
    if (window.innerWidth <= 768) {
      initCarousel();
    }
    
    // Reinicializar si cambia el tamaño de la ventana
    window.addEventListener('resize', function() {
      if (window.innerWidth <= 768) {
        initCarousel();
      }
    });
    
    function initCarousel() {
      const carousel = document.querySelector('.lop-carousel');
      const blocks = document.querySelectorAll('.lop-block');
      const dots = document.querySelectorAll('.lop-dot');
      
      if (!carousel || blocks.length === 0) return;
      
      let currentIndex = 0;
      
      // Marcar el primer punto como activo
      if (dots.length > 0) {
        dots[0].classList.add('active');
      }
      
      // Configurar el desplazamiento táctil
      let touchStartX = 0;
      let touchEndX = 0;
      
      carousel.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, false);
      
      carousel.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }, false);
      
      function handleSwipe() {
        if (touchEndX < touchStartX) {
          // Deslizar a la izquierda
          if (currentIndex < blocks.length - 1) {
            scrollToBlock(currentIndex + 1);
          }
        } else if (touchEndX > touchStartX) {
          // Deslizar a la derecha
          if (currentIndex > 0) {
            scrollToBlock(currentIndex - 1);
          }
        }
      }
      
      function scrollToBlock(index) {
        if (index >= 0 && index < blocks.length) {
          currentIndex = index;
          
          const blockWidth = blocks[0].offsetWidth;
          const scrollPosition = blockWidth * currentIndex;
          
          carousel.scrollTo({
            left: scrollPosition,
            behavior: 'smooth'
          });
          
          // Actualizar indicadores
          dots.forEach((dot, i) => {
            dot.classList.toggle('active', i === currentIndex);
          });
        }
      }
      
      // Configurar clic en los indicadores
      dots.forEach((dot, index) => {
        dot.addEventListener('click', function() {
          scrollToBlock(index);
        });
      });
    }
  });